/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { sectionCss } from '../style'
import React from 'react'
import Conservative from './conservative'
import HighYielding from './high-yielding'
import MostActivelyTraded from './most-actively-traded'
import TaxAdvantaged from './tax-advantaged'

export default () => {
    return <React.Fragment>
    <div id="quick-ideas" className="vertical-offset-sm"></div>
    <div data-name="overview-quick-ideas" className="container vertical-offset-sm" css={sectionCss}>
        <div className="row vertical-offset-sm"></div>
        <div className="row">
        <div className="col-md-12 col-xs-12">
            <h3 className="medium-header">Quick ideas</h3>
            <p className="text-body">Here are some bond ideas to help simplify your investing experience.</p>
        </div>
        </div>

        <Conservative />
        <TaxAdvantaged />
        <MostActivelyTraded />
        <HighYielding />

    </div>
    </React.Fragment>
}




// WEBPACK FOOTER //
// ./src/overview/quick-ideas/quick-ideas.js